import React from 'react';

export default function Footer(param) {

    return(
        <div>
            <footer className="main-footer text-center">
                <strong>Copyright &copy; 2019 <a href="http://mediex.co.kr/"> MedicalExcellence Inc</a>.</strong>
                All rights reserved.
            </footer>
        </div>
    );
}